var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1037 3.3333L12.2687 2.0833C12.7425 1.80975 13.2657 1.63213 13.8082 1.56072C14.3506 1.48931 14.9019 1.52546 15.4305 1.66703C15.959 1.80866 16.4544 2.053 16.8886 2.3861C17.3227 2.71919 17.6868 3.13457 17.9604 3.60847C18.234 4.08227 18.4117 4.60542 18.4831 5.1479C18.5545 5.69037 18.5184 6.24159 18.3767 6.7701C18.2351 7.29875 17.9908 7.79419 17.6577 8.22828C17.3246 8.66238 16.9092 9.0266 16.4354 9.30015L14.2703 10.5501M9.94015 13.0502L7.77509 14.3002C7.30122 14.5737 6.77814 14.7514 6.23565 14.8228C5.69316 14.8942 5.14191 14.8581 4.61334 14.7164C3.54592 14.4304 2.63585 13.7321 2.08335 12.7751C1.5308 11.8181 1.38106 10.6808 1.66708 9.61333C1.95309 8.54592 2.65143 7.63584 3.60844 7.08331L5.7735 5.83331",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13574 9.85805L12.9093 6.5247",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFamily);
export default __webpack_public_path__ + "static/media/link-family.b7b677b5b9e10bf14e3878807920491d.svg";
export { ForwardRef as ReactComponent };